// extracted by mini-css-extract-plugin
export default {"popoverContent":"custom-popover_popoverContent__J59Pa","popoverButtons":"custom-popover_popoverButtons__O5DLo"};